var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('small-subheader',[_c('span',{staticClass:"title font-weight-medium"},[_vm._v("General Terms and Conditions of Use")])])}
var staticRenderFns = []

export { render, staticRenderFns }